module.exports = __webpack_public_path__ + "static/media/Graphic1.0dde916e.png";